// tslint:disable:no-any completed-docs
export function mapArrayCounter(
  array: any[],
  countField: string,
  pushField: string,
) {
  const resultArray: any[] = [];

  array.map((field) => {
    for (let i = 0; i < field[countField]; i++) {
      resultArray.push(field[pushField]);
    }
  });

  return resultArray;
}
